import axios from "axios";
import { getHeaders, checkStatus } from "../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
const baseURL = process.env.REACT_APP_BASE_URL;

  // For ADD the Emp Leaves.
  export const AddOrgEmpLeaves = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseURL}/Leave/Apply`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

//For get the Leave Details.
export const getLeaveDetailsList = async (params) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Leave/List`,params,{
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
    
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


// For get the Leave Type.
export const getLeaveMasterType = async (params) =>{
  try{
    const response = await axiosInstance.get(`${baseURL}/Leave/type`,
     {
      params: {
        OrgId: params.OrgId,
    },
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response); 
    return response.data;
  }catch (error){
    return Promise.reject(error);
  }
}
 // For Update the status of Leave .
 export const rejectLeaveStatus = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Leave/Reject`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

 // For Update the status of Leave .

 export async function withdrwalLeaveStatus(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Leave/Withdraw`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

 // For Update the status of Leave .
 export const approveLeaveStatus = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Leave/Approve`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

 // For Post Organization Leave .
 export async function postOrganizationHolidays(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Leave/Holidays/Add`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

 // For GEt Leave dashboard count.
export const leaveDashboardBalenceCount = async (params) =>{
  try{
    const response = await axiosInstance.get(`${baseURL}/Leave/Balance`,
     {
      params: {
        EmpId: params.EmpId,
        TypeId: params.TypeId,
    },
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response); 
    return response.data;
  }catch (error){
    return Promise.reject(error);
  }
}

 // For Get Organization Holidays.
 export async function getOrganizationHolidays(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Leave/Holidays`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

 // For Delete Organization Leave .
 export const deleteOrganizationData = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Leave/Holidays/Delete`,
      null,
      {
        params: {
          id: params.id,
        },
        headers: await getHeaders(),
      }
    );
    
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// For GET Leave Ledger  Details.
export async function getLeaveLedgerDetails(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Leave/Ledger`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

 // For Delete Organization Leave .
 export const postHolidayMaster = async (params) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Master/HolidayMaster`,
      null,
      {
        params: {
          organisationId: params.organisationId,
        },
        headers: await getHeaders(),
      }
    );
    
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

  // For ADD the Emp Leaves.
  export const PostLeaveAdjustment = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseURL}/Leave/Adjustment`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  // leave Years 

  export const getLeaveYear = async (params) => {
    try {
      const response = await axiosInstance.get(`${baseURL}/Leave/Years?OrgId=${params.OrgId}`, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

//Organization Setting Leaves

export const getOrganizationLeaves = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseURL}/Leave/Type?OrgId=${params.OrgId}`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }


//Organization Setting Leaves Delete

export const deleteOrganizationLeaves = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseURL}/Leave/Type/Delete`,
      {
        headers: await getHeaders(),
        data: params                 // sending body via config.data
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};



//Organization Setting Leave  Edit/Add 

  export const addOrganizationLeaves = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseURL}/Leave/Type/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };